import {
  TaskSchemaStaticNodeData,
  TaskSchemaNode,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TaskSchemaNodeRenderer';
import {
  FlowchartStaticEdgeData,
  FlowchartEdge,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

import {NodeTransitionPosition} from './transitionModalWithFlowchartEditorConstants';
import {
  createTaskNode,
  createNodePosition,
  FlowchartOptions,
} from './transitionModalWithFlowchartEditorUtils';

interface FlowchartData {
  sourceNodes: Array<TaskSchemaNode>;
  targetNode: TaskSchemaNode | null;
  edges: Array<FlowchartEdge>;
}

interface BuildFlowchartFromTransitionDataRunnerArgs {
  sourceNodesStaticData: Array<TaskSchemaStaticNodeData>;
  targetNodeStaticData: TaskSchemaStaticNodeData | null;
  edgesData: Array<FlowchartStaticEdgeData>;
  options: FlowchartOptions;
}

class BuildFlowchartFromTransitionDataRunner {
  private readonly sourceNodesStaticData: Array<TaskSchemaStaticNodeData>;
  private readonly targetNodeStaticData: TaskSchemaStaticNodeData | null;
  private readonly edgesData: Array<FlowchartStaticEdgeData>;
  private readonly options: FlowchartOptions;
  private sourceNodes: Array<TaskSchemaNode>;
  private targetNode: TaskSchemaNode | null;
  private edges: Array<FlowchartEdge>;

  constructor(args: BuildFlowchartFromTransitionDataRunnerArgs) {
    this.sourceNodesStaticData = args.sourceNodesStaticData;
    this.targetNodeStaticData = args.targetNodeStaticData;
    this.edgesData = args.edgesData;
    this.options = args.options;
    this.sourceNodes = [];
    this.targetNode = null;
    this.edges = [];
  }

  run(): FlowchartData {
    this.convertStaticDataToNodes(this.options);
    this.convertStaticDataToEdges(this.options);
    return {
      sourceNodes: this.sourceNodes,
      targetNode: this.targetNode,
      edges: this.edges,
    };
  }

  private convertStaticDataToNodes(options: FlowchartOptions): void {
    this.sourceNodes = this.sourceNodesStaticData.map((sourceStaticData, index) =>
      createTaskNode(
        sourceStaticData,
        createNodePosition({
          nodeTransitionPosition: NodeTransitionPosition.SOURCE,
          indexInNodeTransitionPosition: index,
        }),
        options
      )
    );

    this.targetNode = this.targetNodeStaticData
      ? createTaskNode(
          this.targetNodeStaticData,
          createNodePosition({
            nodeTransitionPosition: NodeTransitionPosition.TARGET,
            indexInNodeTransitionPosition: 0,
          }),
          options
        )
      : null;
  }

  private convertStaticDataToEdges(options: FlowchartOptions): void {
    this.edges = this.edgesData as Array<FlowchartEdge>;
  }
}

export default function buildFlowchartFromTransitionData(
  args: BuildFlowchartFromTransitionDataRunnerArgs
): FlowchartData {
  const runner = new BuildFlowchartFromTransitionDataRunner(args);
  return runner.run();
}
